import r from 'render-dom';
import styled from 'styled-components';

const Container = styled.span`
    align-items: center;
    border-radius: 5px;
    box-sizing: border-box;
    color: #999;
    cursor: pointer;
    display: flex;
    font-size: 16px;
    overflow: hidden;
    padding: 7px 10px;
    white-space: nowrap;
    width: 100%;

    &:hover {
        background: #eaeaea;
        color: #000;
    }

    &.selected {
        color: #555;
        padding-bottom: 0;
        padding-top: 0;
    }
`;

export default function Option({ label, onClick, selected, value }) {
    return (
        r(Container, {
            className: selected ? 'selected' : '',
            onClick: () => onClick(value)
        }, [label])
    );
}
